export function selectEndPoint(type) {
    switch(type) {
      case 'faq':
        return 'faq/questions';

      default:
        return '';
    };
  };
